var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"page"}},[_c('v-app',[_c('transition',{attrs:{"mode":"out-in","name":"slide-fade"}},[(!_vm.getIsNotFound)?_c('router-view',{staticClass:"router-view"}):_c('ErrorPage')],1),_c('TheCookies')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }